export const About = () => {
    return (
        <section id="about" className="py-5">
            <div className="container text-center">
                <h2 className="fw-bold mb-4">About Solaris Energy</h2>
                <p className="lead text-muted mb-5">
                    At Solaris Energy, we are committed to creating a sustainable world by harnessing the power of the sun.
                    Our team provides top-tier solar panel installations, maintenance, and energy optimization services.
                </p>

                <div className="row">
                    <div className="col-md-4">
                        <div className="feature-icon mb-3">☀️</div>
                        <h5>Clean Energy</h5>
                        <p>Reduce your carbon footprint with efficient, eco-friendly solar systems.</p>
                    </div>
                    <div className="col-md-4">
                        <div className="feature-icon mb-3">💰</div>
                        <h5>Cost Savings</h5>
                        <p>Save on electricity bills and enjoy government incentives for renewable energy.</p>
                    </div>
                    <div className="col-md-4">
                        <div className="feature-icon mb-3">🔋</div>
                        <h5>Reliable Power</h5>
                        <p>Enjoy uninterrupted energy with advanced solar and battery storage systems.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}